exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-investors-invited-___style__header___3icRj{display:flex;justify-content:space-between}.web-flows-deal-investors-invited-___style__h2___2Ol2d{border-bottom:none!important}.web-flows-deal-investors-invited-___style__table___2JdRu{display:flex;flex-flow:column nowrap;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"header": "web-flows-deal-investors-invited-___style__header___3icRj",
	"h2": "web-flows-deal-investors-invited-___style__h2___2Ol2d",
	"table": "web-flows-deal-investors-invited-___style__table___2JdRu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/investors/invited/style.css
// module id = 1344
// module chunks = 0